import { Chart, Plugin } from 'chart.js';
import {
  SITE_PERFORMANCE_CHART_BAR_HEIGHT,
  SITE_PERFORMANCE_CHART_Y_AXIS_LEFT_TICK_LENGTH,
} from 'app/modules/site-management/widgets/fleet-dashboard/constants/SitePerformanceChart.constants';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';

const BAR_HALF_HEIGHT = SITE_PERFORMANCE_CHART_BAR_HEIGHT / 2;
const Y_AXIS_LINE_WIDTH = 2;

const drawHorizontalSeparator = (
  ctx: CanvasRenderingContext2D,
  chartAreaLeft: number,
  chartAreaRight: number,
  y: number
): void => {
  ctx.beginPath();
  ctx.moveTo(chartAreaLeft, y);
  ctx.lineTo(chartAreaRight, y);
  ctx.stroke();
};

const drawYAxisOverlay = (chart: Chart): void => {
  const { ctx, chartArea } = chart;

  if (!chartArea) {
    return;
  }

  ctx.save();
  ctx.strokeStyle = kccThemeConstants.COLORS.GRAY_700;
  ctx.lineWidth = Y_AXIS_LINE_WIDTH;

  ctx.beginPath();
  ctx.moveTo(chartArea.left, chartArea.top);
  ctx.lineTo(chartArea.left, chartArea.bottom);
  ctx.stroke();

  ctx.restore();
};

export const sitePerformanceChartJsCategoryGridPlugin: Plugin = {
  id: 'sitePerformanceChartJsCategoryGrid',
  beforeDatasetsDraw(chart: Chart): void {
    const { ctx, chartArea, data } = chart;
    const categoryCount = data.labels?.length ?? 0;
    const actualMeta = chart.getDatasetMeta(0);

    if (!chartArea || categoryCount === 0 || actualMeta.hidden) {
      return;
    }

    ctx.save();
    ctx.strokeStyle = kccThemeConstants.COLORS.GRAY_100;
    ctx.lineWidth = 2;

    for (let index = 0; index < categoryCount; index += 1) {
      const actualBar = actualMeta.data[index];

      if (actualBar) {
        const actualBarBottom = actualBar.y + BAR_HALF_HEIGHT;
        drawHorizontalSeparator(ctx, chartArea.left, chartArea.right, actualBarBottom);
      }
    }

    ctx.restore();
  },
  afterDraw(chart: Chart): void {
    const { ctx, chartArea, data } = chart;
    const categoryCount = data.labels?.length ?? 0;
    const actualMeta = chart.getDatasetMeta(0);

    if (!chartArea || categoryCount === 0 || actualMeta.hidden) {
      return;
    }

    drawYAxisOverlay(chart);

    ctx.save();
    ctx.strokeStyle = kccThemeConstants.COLORS.GRAY_700;
    ctx.lineWidth = Y_AXIS_LINE_WIDTH;

    for (let index = 0; index < categoryCount; index += 1) {
      const actualBar = actualMeta.data[index];

      if (actualBar) {
        const actualBarBottom = actualBar.y + BAR_HALF_HEIGHT;

        ctx.beginPath();
        ctx.moveTo(chartArea.left - SITE_PERFORMANCE_CHART_Y_AXIS_LEFT_TICK_LENGTH, actualBarBottom);
        ctx.lineTo(chartArea.left, actualBarBottom);
        ctx.stroke();
      }
    }

    ctx.restore();
  },
};
